import { useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function InquiryForm({ cake = null, compact = false }) {
    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        event_date: "",
        message: cake ? `I'd love to enquire about your ${cake.name} cake.` : "",
    });
    const [submitting, setSubmitting] = useState(false);

    const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

    const onSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        try {
            await api.post("/inquiries", {
                ...form,
                cake_slug: cake?.slug,
                cake_name: cake?.name,
            });
            toast.success("Thank you! Your enquiry has been sent. We'll be in touch shortly.");
            setForm({ name: "", email: "", phone: "", event_date: "", message: "" });
        } catch (err) {
            toast.error(formatApiErrorDetail(err.response?.data?.detail));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <form onSubmit={onSubmit} className="space-y-4" data-testid="inquiry-form">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-[10px] tracking-[0.25em] uppercase text-ink-soft mb-2">Name</label>
                    <input
                        type="text"
                        name="name"
                        required
                        value={form.name}
                        onChange={onChange}
                        className="w-full px-4 py-3 bg-transparent border border-[#EAE3DE] focus:outline-none focus:border-blush text-ink"
                        data-testid="inquiry-name"
                    />
                </div>
                <div>
                    <label className="block text-[10px] tracking-[0.25em] uppercase text-ink-soft mb-2">Email</label>
                    <input
                        type="email"
                        name="email"
                        required
                        value={form.email}
                        onChange={onChange}
                        className="w-full px-4 py-3 bg-transparent border border-[#EAE3DE] focus:outline-none focus:border-blush text-ink"
                        data-testid="inquiry-email"
                    />
                </div>
                <div>
                    <label className="block text-[10px] tracking-[0.25em] uppercase text-ink-soft mb-2">Phone</label>
                    <input
                        type="tel"
                        name="phone"
                        value={form.phone}
                        onChange={onChange}
                        className="w-full px-4 py-3 bg-transparent border border-[#EAE3DE] focus:outline-none focus:border-blush text-ink"
                        data-testid="inquiry-phone"
                    />
                </div>
                <div>
                    <label className="block text-[10px] tracking-[0.25em] uppercase text-ink-soft mb-2">Event Date</label>
                    <input
                        type="date"
                        name="event_date"
                        value={form.event_date}
                        onChange={onChange}
                        className="w-full px-4 py-3 bg-transparent border border-[#EAE3DE] focus:outline-none focus:border-blush text-ink"
                        data-testid="inquiry-date"
                    />
                </div>
            </div>
            <div>
                <label className="block text-[10px] tracking-[0.25em] uppercase text-ink-soft mb-2">
                    Tell us about your cake
                </label>
                <textarea
                    name="message"
                    rows={compact ? 4 : 6}
                    required
                    value={form.message}
                    onChange={onChange}
                    className="w-full px-4 py-3 bg-transparent border border-[#EAE3DE] focus:outline-none focus:border-blush text-ink resize-none"
                    placeholder="Occasion, servings, flavours, design ideas…"
                    data-testid="inquiry-message"
                />
            </div>
            <button
                type="submit"
                disabled={submitting}
                className="btn-pink disabled:opacity-60"
                data-testid="inquiry-submit"
            >
                {submitting ? "Sending…" : "Send Enquiry"}
            </button>
        </form>
    );
}
